import { Admin as AdminType } from 'features/Main/Admins/types'

// eslint-disable-next-line no-shadow
export enum Role {
  SuperAdmin = 'super_admin',
  Admin = 'admin',
  Marketing = 'marketing',
  Analyst = 'analyst',
  Employee = 'employee',
}

/**
 * Obtiene el rol del usuario (asumiendo un solo rol por usuario)
 */
export const getUserRole = (admin: AdminType | undefined): Role | null => {
  if (!admin || !admin.roles || admin.roles.length === 0) return null
  return admin.roles[0].name as Role
}

/**
 * Verifica si el usuario tiene uno de los roles especificados
 */
export const hasRole = (admin: AdminType | undefined, allowedRoles: Role[]): boolean => {
  const userRole = getUserRole(admin)
  if (!userRole) return false
  return allowedRoles.includes(userRole)
}

/**
 * Verifica si el usuario tiene acceso a un módulo según su rol
 */
export const hasModuleAccess = (admin: AdminType | undefined, module: string): boolean => {
  const userRole = getUserRole(admin)
  if (!userRole) return false

  // SuperAdmin tiene acceso a todo
  if (userRole === Role.SuperAdmin) return true

  if (module === 'reviews') {
    if (userRole === Role.Admin) return true
    if (userRole === Role.Analyst) return true
    if (userRole === Role.Marketing) return true
    return false
  }

  // Admin tiene acceso a todo excepto crear/editar/eliminar admins
  if (userRole === Role.Admin) {
    return module !== 'admins' // Los admins solo pueden ver, no gestionar
  }

  // Marketing: campaigns y analytics (reviews se resuelve arriba)
  if (userRole === Role.Marketing) {
    return module === 'campaigns' || module === 'analytics'
  }

  // Analyst solo tiene acceso a analytics
  if (userRole === Role.Analyst) {
    return module === 'analytics'
  }

  return false
}

/**
 * Verifica si el usuario puede responder/modificar reseñas
 */
export const canRespondToReviews = (admin: AdminType | undefined): boolean => {
  const userRole = getUserRole(admin)
  if (!userRole) return false

  if (userRole === Role.SuperAdmin || userRole === Role.Admin) return true
  if (userRole === Role.Analyst || userRole === Role.Marketing) {
    return admin?.reviewsCanRespond === true
  }

  return false
}

/**
 * Obtiene la ruta inicial según el rol del usuario
 */
export const getDefaultRoute = (admin: AdminType | undefined): string => {
  const userRole = getUserRole(admin)

  if (!userRole) return '/users'

  // Marketing debe iniciar en campaigns
  if (userRole === Role.Marketing) {
    return '/campaigns'
  }

  // Analyst debe iniciar en new-dashboard
  if (userRole === Role.Analyst) {
    console.log('[getDefaultRoute] Analyst role detected, returning /new-dashboard')
    return '/new-dashboard'
  }

  // SuperAdmin y Admin pueden iniciar en users (o cualquier módulo)
  return '/users'
}
